import './Select.scss';
import ListItem from "../ListBox/ListItem";
import {IIconSelectItem} from "./IconSelect";

export default class IconSelectItem extends ListItem {

	private _icon: HTMLElement;
	private _content: HTMLElement;

	constructor(settings: object)
	{
		super(settings);
	}

	_render()
	{
		let icon = `<i for="${this._Id}" class="icon-select__item__icon app-list-item__graphic ${this._FontImage || ''}"></i>`;

		this._initComponent(`<div class="icon-select__item">
										${icon}
										<span class="icon-select__item__text"></span> 
									</div>`);

		this._renderItems([this._root], this._ParentNode || document.documentElement);
		this._icon = this._root.querySelector('.icon-select__item__icon');
		this._content = this._root.querySelector('.icon-select__item__text');
	}

	refresh(args :IIconSelectItem)
	{
		this.setValue(args.Value, false);
		this.setFontImage(args.FontImage);
		this.setContent(args.Content || args.RK);
	}

	setContent(value: string)
	{
		this._content.innerHTML = value;
	}
};